import { RiDeleteBin6Line } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { dropWarehouse } from "../../../slice/warehouseSlice";
import { confirmPasswordUrl, deleteWarehouseUrl } from "../../../api/endpoints";
import { useNavigate } from "react-router-dom";
import { setUser } from "../../../slice/webStoreUserSlice";
import { ButtonLoader } from "../../../components/uxCollections/Loaders";
import { useState } from "react";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";

const WarehouseNameandInfo = ({ warehouse, setWarehouse }) => {
  const [openModal, setOpenModal] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleDelete = async () => {
    try {
      let response = await fetch(deleteWarehouseUrl + warehouse._id, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      if (response.ok) {
        let user = await response.json();
        dispatch(setUser(user));
        navigate("/mystores");
        dispatch(dropWarehouse());
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className='storeNameandinfo' style={{ marginBottom: "16px", display: "flex" }}>
        <div>
          <div className='storeImageDiv34'>
            <img className='storeImgaeplace' src={warehouse.warehouseIcon} />
          </div>
          <div>
            <div>
              <h4 style={{ fontSize: "14px", fontWeight: 700 }}>{warehouse.warehouseName}</h4>
              <p style={{ fontSize: "0.8rem", color: "gray" }}>{warehouse.warehouseAddress}</p>
            </div>
          </div>
        </div>
        <div className='publicSwitch'>
          <div style={{ justifyContent: "end", display: "flex" }}>
            <RiDeleteBin6Line onClick={() => setOpenModal(true)} size={24} color={"red"} style={{ cursor: "pointer" }} />
          </div>
        </div>
      </div>
      {openModal && <EnterPassword setOpenModal={setOpenModal} handleDelete={handleDelete} />}
    </>
  );
};

export default WarehouseNameandInfo;

const EnterPassword = ({ setOpenModal, handleDelete }) => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const { user } = useSelector((state) => state.webStoreUser);
  const anyUsersStore = user?.store && user.store.length > 0 && user.store[0];

  if (!anyUsersStore) {
    uiAlert("No store found for the user", "error");
    return null; // or some fallback UI
  }

  //confirm password for edit
  const confirmPassword = async () => {
    setLoading(true);
    let accessToken = localStorage.getItem("accessToken");
    let storeID = anyUsersStore._id;
    console.log(confirmPasswordUrl + storeID, accessToken, password);

    try {
      let response = await fetch(confirmPasswordUrl + storeID, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ password }),
      });

      if (response.ok) {
        uiAlert("password confirmed successfully, deleting warehouse", "success");
        handleDelete();
      } else if (response.status === 401) {
        uiAlert("password is incorrect, try again", "error");
        setLoading(false);
        setPassword("");
      }
    } catch (error) {
      uiAlert("something went wrong, try again", "error");
      setLoading(false);
      console.log(error);
    }
  };
  return (
    <div onClick={() => setOpenModal(false)} className='confirmPasswordWrapper'>
      <div onClick={(e) => e.stopPropagation()} className='confirmPasswordDiv988'>
        {/* confirm passwaod */}
        <h3>Enter password</h3>
        <input
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              confirmPassword();
            }
          }}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className='DePas7364'
          type='password'
          placeholder='password'
        />

        {password ? (
          loading ? (
            <button>
              {" "}
              <ButtonLoader />{" "}
            </button>
          ) : (
            <button onClick={confirmPassword}>Confirm and delete</button>
          )
        ) : (
          <button style={{ opacity: "0.7", cursor: "not-allowed" }}>Confirm and delete</button>
        )}
      </div>
    </div>
  );
};
